import { ValidationSchema } from '../../../../../../@types/validation-types'
import {
  defaultConstruction,
  defaultContactInfo,
  useWebViewManualAndInternationalAddress,
} from '../../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../../services/validation/rules/validationRules'

export const webViewTenantApartmentRentSchema: ValidationSchema = {
  address: useWebViewManualAndInternationalAddress,
  basicInfo: {
    livingSpace: validationRules.livingSpace,
    room: validationRules.room,
    startRentalDate: validationRules.startRentalDateRequired,
  },
  costs: {
    price: validationRules.price,
    additionalCosts: validationRules.additionalCosts,
    deposit: validationRules.deposit,
    heatingCosts: validationRules.heatingCosts,
  },
  description: {
    adTitle: validationRules.adTitle,
    adDescription: validationRules.adDescription,
    adLocation: validationRules.adLocation,
  },
  contactInfo: defaultContactInfo,
  objectDetails: {
    noBathrooms: validationRules.noBathrooms,
    noBedrooms: validationRules.noBedrooms,
    floor: validationRules.floor,
    totalFloorsNumber: validationRules.totalFloorsWithDependingFloorNumber,
  },
  construction: defaultConstruction,
}
